module.exports = __webpack_public_path__ + "img/winners-rafiki.f4e195df.svg";